export enum BreedingMethodClassMethodEnum {
    NON_BULKING_BREEDING_METHOD_CLASS = 1510
}
